import React, { useEffect } from "react";
import HomeReviews from "../components/homepage-components/HomeReviews";
import Faq from "../components/universal-components/Faq";
import Hero from "../components/Hero";
import Intro from "../components/Intro";
import ContentLeft from "../components/ContentLeft";
import ContentRight from "../components/ContentRight";
import CallToAction from "../components/CallToAction";
import { serviceContent } from "../page-content/servicingContent";

const BoilerService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={serviceContent} />
      <Intro data={serviceContent} />
      <ContentLeft data={serviceContent} />
      <ContentRight data={serviceContent} />
      <CallToAction data={serviceContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default BoilerService;
